module.exports = __webpack_public_path__ + "jab/media/delete-disable.ce6bdf2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/delete-disable.svg
// module id = 320
// module chunks = 0